import initIframe from './iframe';
import CustomPlayer from './customPlayer';

// Youtube or Vimeo using a data-url attribute
document.querySelectorAll('.video__player[data-url]')
  .forEach($video => initIframe($video));

// Custom Player
document.querySelectorAll('.js-video-custom-player')
  .forEach($video => new CustomPlayer($video));
